import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4748790c")

_pushScopeId("data-v-4748790c")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("扣费说明")
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("补扣费说明")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("账单信息")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("合同信息")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "扣费详情",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
    width: "850px",
    "destroy-on-close": "",
    "before-close": _ctx.handleClose
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_17, [
        _createVNode(_component_el_button, { onClick: _ctx.handleClose }, {
          default: _withId(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        class: "formRef",
        ref: "formRef",
        "label-width": "110px"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_row, null, {
            default: _withId(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.uuid), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "费用项目：" }, {
                    default: _withId(() => [
                      _createVNode("span", null, _toDisplayString(_ctx.feeType[_ctx.deductionRecord?.feeType]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "数量：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.amount), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "费率：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.price) + " ", 1),
                      (_ctx.deductionRecord?.price)
                        ? (_openBlock(), _createBlock("span", _hoisted_2))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "实扣费用：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.fee) + " ", 1),
                      (_ctx.deductionRecord?.fee)
                        ? (_openBlock(), _createBlock("span", _hoisted_3, "元"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "创建时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.createTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费状态：" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_tag, {
                        type: _ctx.deductionRecord?.state === 1 ? 'success' : 'danger'
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.state[_ctx.deductionRecord?.state]), 1)
                        ]),
                        _: 1
                      }, 8, ["type"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.deductionRecord?.deductTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "原因说明：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.reason[_ctx.deductionRecord?.reason] || '--'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "扣费明细：" }, {
                    default: _withId(() => [
                      _createVNode("span", null, "实缴金额 " + _toDisplayString(_ctx.deductionRecord?.deductByPayAmount) + " 元 ", 1),
                      _createVNode("span", null, "优惠金额 " + _toDisplayString(_ctx.deductionRecord?.deductByGivingMoney) + " 元", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.fillDeductionRecord?.payUuid)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_divider, { "content-position": "left" }, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "缴费编号：" }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.fillDeductionRecord?.payUuid), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "第三方流水号：" }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.fillDeductionRecord?.xxx || '--'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "缴费时间：" }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.fillDeductionRecord?.payTime), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "创建时间：" }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.fillDeductionRecord?.createTime), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "缴费备注：" }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.fillDeductionRecord?.payRemark), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "账单编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.billNo), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "账单金额：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.money || '0') + " 元 ", 1),
                      (_ctx.contractBill?.billStatus)
                        ? (_openBlock(), _createBlock("span", _hoisted_6, " （" + _toDisplayString(_ctx.billStatus[_ctx.contractBill?.billStatus]) + "） ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "账单类型：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.typeName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "应付时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.estimatedPayTime) + " ", 1),
                      (_ctx.contractBill?.overdueStatus === 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.overdueStatus[_ctx.contractBill?.overdueStatus]) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "实际支付时间：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.payTime), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "账单周期：" }, {
                    default: _withId(() => [
                      (_ctx.contractBill?.startTime && _ctx.contractBill?.endTime)
                        ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.dayjs(_ctx.contractBill?.startTime).format('YYYY-MM-DD HH:mm')) + " - " + _toDisplayString(_ctx.dayjs(_ctx.contractBill?.endTime).format('YYYY-MM-DD HH:mm')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "收支渠道：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.payChannel[_ctx.contractBill?.payChannel]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "第三方流水号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBill?.thirdTradeNo), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_divider, { "content-position": "left" }, {
                default: _withId(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "合同编号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contract?.contractNo), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "车架号：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contract?.vin), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "司机：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contract?.driverName) + " ", 1),
                      (_ctx.contract?.driverName && _ctx.contract?.driverMobile)
                        ? (_openBlock(), _createBlock("span", _hoisted_10, "（" + _toDisplayString(_ctx.contract?.driverMobile) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "车辆：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contract?.carNo) + " ", 1),
                      (_ctx.contract?.carModelName)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, "（" + _toDisplayString(_ctx.contract?.carModelName) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "承租方式：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.rentType[_ctx.contract?.rentType]) + " ", 1),
                      (_ctx.contract?.classesType)
                        ? (_openBlock(), _createBlock("span", _hoisted_12, "（" + _toDisplayString(_ctx.classesType[_ctx.contract?.classesType]) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "工作时间：" }, {
                    default: _withId(() => [
                      (_ctx.contract?.workStartTime)
                        ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.contract?.workStartTime) + " 至 当日 " + _toDisplayString(_ctx.contract?.workEndTime), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "收租方式：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.chargeType[_ctx.contract?.chargeType]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "账单生成模式：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.contractBillType[_ctx.contract?.contractBillType] || '--'), 1),
                      (_ctx.contract?.contractBillType === '2')
                        ? (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.weekTranstionCN(_ctx.contract?.contractBillTypeWeek)), 1))
                        : _createCommentVNode("", true),
                      (_ctx.contract?.contractBillType === '3')
                        ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.contract?.contractBillTypeMonth), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "租金费用：" }, {
                    default: _withId(() => [
                      (_ctx.contract?.monthCash)
                        ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.contract?.monthCash) + " 元/天", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "付款方式：" }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.moneyType[_ctx.contract?.moneyType]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
})